export default __webpack_public_path__ + "static/media/searchTokenIcon.36f033c8.svg";